import { questionnaireGql } from '../../../gql-gen/questionnaire'

// `surveyId` must be selected: `draftAudienceV2` returns a
// DraftFieldworkAudience, which the Apollo type policy (apolloClient.ts) keys by
// `surveyId`. Without it, writing this query's result to the cache throws
// "Missing field 'surveyId' while extracting keyFields" and crashes the
// audience editor. The DraftAudience fragment selects it for the same reason.
export const AUDIENCE_VALIDATION_ERRORS = questionnaireGql(/* GraphQL */ `
  query audienceValidationErrors($projectId: ID!, $surveyId: ID!, $waveId: ID) {
    draftAudienceV2(
      projectId: $projectId
      surveyId: $surveyId
      waveId: $waveId
    ) {
      surveyId
      validationErrors {
        __typename
        ...CustomCriterionValidationErrors
        ...StandardCriterionValidationErrors
      }
    }
  }
`)
